<script setup>
import {ref, computed, onMounted} from 'vue'
import {useAuthStore} from './stores/authStores'
import LeftToolbar from './components/leftToolbar/LeftToolbar.vue'
import HeaderSection from './components/HeaderSection.vue'
import LTE from "@/components/LTE/LTE.vue";
import SDS from "@/components/SDS.vue";
import AlarmsHistory from "@/components/AlarmsHistory.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import LoginForm from './components/LoginForm.vue';
import RightToolbar from "@/components/RightToolbar.vue";
import AlarmPopup from "@/components/AlarmPopup.vue";
import {keycloak} from '@/main'
import {useMediaStore} from "@/stores/mediaStore";
import LoginFormAdmin from "@/components/LoginFormAdmin.vue";

const selected = ref(useMediaStore().selectedTab)
const authStore = useAuthStore()

const tokenParsed = ref(null);

onMounted(() => {
  // initial
  tokenParsed.value = keycloak.tokenParsed;

  // keep it updated when Keycloak refreshes/authenticates
  keycloak.onAuthSuccess = () => (tokenParsed.value = keycloak.tokenParsed);
  keycloak.onAuthRefreshSuccess = () => (tokenParsed.value = keycloak.tokenParsed);
  keycloak.onTokenExpired = () => (tokenParsed.value = keycloak.tokenParsed);
});

const clientRoles = computed(() =>
    tokenParsed.value?.resource_access?.["cairo-metro4-api"]?.roles ?? []
);

const isAdmin = computed(() => clientRoles.value.includes("Admin"));


const currentComponent = computed(() => {
  switch (useMediaStore().selectedTab) {
    case 'RADIO':
      return LTE
    case 'SDS':
      return SDS
    case 'ALARMS':
      return AlarmsHistory
    default:
      return null
  }
})

</script>

<template>
  <!-- Login Modal -->
  <LoginFormAdmin v-if="authStore.showLoginForm && isAdmin" key="admin" />
  <LoginForm v-else-if="authStore.showLoginForm" key="user" />

  <v-app v-if="!authStore.showLoginForm">
    <AlarmPopup/>
    <v-layout ref="app" class="rounded rounded-md border" style="height: 1px;">
      <!-- Header -->
      <HeaderSection/>

      <!-- Left Drawer -->
      <LeftToolbar v-model:selected="selected"/>
      <!-- Right Drawer -->
      <RightToolbar :selected="selected"></RightToolbar>
      <!-- Main -->
      <v-main class=" h-100 w-100">
        <v-container class="d-flex h-100 pa-0" fluid>
          <component :is="currentComponent"/>
        </v-container>
      </v-main>
      <!-- Footer -->
      <footer-component/>
    </v-layout>
  </v-app>
</template>

<style>

#app {
  height: 100%;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-size: 15px;
  overflow-x: hidden;
  overflow-y: hidden;
}

:deep(.row-emergency) {
  background-color: #EE5A5AFF;
  color: white;
}

:deep(.row:hover) {
  background-color: #E0E0E0;
}

:deep(.row-emergency:hover) {
  background-color: #933030;
  color: white;
}

:deep(.selected) {
  background-color: #3f3f3f;
  color: white;
}

</style>